
console.log('Env: ', process.env.NODE_ENV);

let apiBaseUrl = 'http://10.0.0.60:3001/api';
apiBaseUrl = 'http://localhost:3001/api';
let stripeKey = 'pk_test_51Rq3IEBe0NPazcvs3El8cNtIv54TXJwfepVAGIy4viss7WCf8e5s0VjfTIX1FgwdG3QfpbSfuz5mZ70hSWUbwHvt00OGJODqZr';
if (process.env.NODE_ENV === 'production') {
  apiBaseUrl = '/api';
  stripeKey = 'pk_live_51Roz2TBrAPh93TLDrOJJndY5GAzoIIZ4chniKOVbldMh0lxS1TRCCwsT4EtktwUXLKUTO1BnGo1PL3xS9TKhmAop00ADRJvWYa';
}

export {
  apiBaseUrl,
  stripeKey
}